import React from 'react';
import {Form, Input, Upload, Button, message} from 'antd';
import {PictureOutlined, LoadingOutlined, PlusOutlined} from '@ant-design/icons';
import 'braft-editor/dist/index.css';
import BraftEditor from 'braft-editor';
import { ContentUtils } from 'braft-utils';
import {api, fileUpload} from "../../request";

export default class ServiceCaseForm extends React.Component{

    static STATE_STRUCT = (url, content) => {
        return {
            editorState: BraftEditor.createEditorState(content ? content : null),
            coverImageUrl: url ? url : '',
            coverImageDisable: false,
            editorImageDisable: false,
        }
    };

    state = ServiceCaseForm.STATE_STRUCT(this.props.defaultFormValue ? this.props.defaultFormValue.cover : '', this.props.defaultFormValue ? this.props.defaultFormValue.content : null);

    render() {
        const finish = values => {
            if (!values.title){
                message.error("请填写例子标题!");
            } else if (!values.desc){
                message.error("请填写例子简介!");
            } else if (!values.pageTitle){
                message.error("请填写例子页面标题!");
            } else if (!values.meta){
                message.error("请填写例子meta!");
            } else if (!this.state.coverImageUrl){
                message.error("请选择例子图片!");
            } else if (this.state.editorState.isEmpty()){
                message.error("请填写例子内容!");
            } else{
                if (this.props.onUpload){
                    this.props.onUpload({
                        title: values.title,
                        desc: values.desc,
                        pageTitle: values.pageTitle,
                        meta: values.meta,
                        cover: this.state.coverImageUrl,
                        content: this.state.editorState.toHTML(),
                    });
                }
            }
        };

        const excludeControls = [
            'media'
        ];

        const extendControls = [
            {
                key: 'antd-uploader',
                type: 'component',
                component: (
                    <Upload
                        accept="image/*"
                        showUploadList={false}
                        disabled={this.state.editorImageDisable}
                        beforeUpload={(file)=>{
                            if (file.size > (2 * 1024 * 1024)){
                                message.error('文件最大2m');
                                return false;
                            }

                            this.setState({editorImageDisable: true});
                            fileUpload(api.addImage, file, (res) => {
                                this.setState({editorImageDisable: false});
                                if (res.code === 200){
                                    this.setState({
                                        editorState: ContentUtils.insertMedias(this.state.editorState, [{
                                            type: 'IMAGE',
                                            url: api.getImage(res.data),
                                        }])
                                    });
                                }
                            });
                            return false;
                        }}
                    >
                        <Button className="control-item button upload-button" data-title="插入图片">
                            <PictureOutlined />
                        </Button>
                    </Upload>
                )
            }
        ];

        const { coverImageUrl } = this.state;

        const uploadButton = (
            <div>
                {this.state.loading ? <LoadingOutlined /> : <PlusOutlined />}
                <div className="ant-upload-text">上传</div>
            </div>
        );

        return (
            <Form name="newsForm" onFinish={finish}
                  initialValues={{
                      ['title'] : this.props.defaultFormValue ? this.props.defaultFormValue.title : '',
                      ['desc'] : this.props.defaultFormValue ? this.props.defaultFormValue.desc : '',
                      ['pageTitle'] : this.props.defaultFormValue? this.props.defaultFormValue.pageTitle : '',
                      ['meta'] : this.props.defaultFormValue? this.props.defaultFormValue.meta : '',
                  }}>
                <Form.Item
                    label="例子标题"
                    name="title"
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="页面标题"
                    name="pageTitle"
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="页面Meta"
                    name="meta"
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="例子简介"
                    name="desc"
                >
                    <Input.TextArea />
                </Form.Item>
                <Form.Item
                    name="cover"
                    label="例子图片">
                    <Upload
                        name="file"
                        listType="picture-card"
                        showUploadList={false}
                        multiple={false}
                        disable={this.state.coverImageDisable}
                        beforeUpload = {(file) => {
                            if (file.size > (2 * 1024 * 1024)){
                                message.error('文件最大2m');
                                return false;
                            }

                            this.setState({coverImageDisable: true});
                            fileUpload(api.addImage, file, (res) => {
                                this.setState({coverImageDisable: false});
                                if (res.code === 200){
                                    this.setState({coverImageUrl: api.getImage(res.data)});
                                }
                            });
                            return false;
                        }}>
                        {coverImageUrl ? <img src={coverImageUrl} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                    </Upload>
                </Form.Item>
                <label style={{height: 14, color: "black", fontSize: 14}}>例子内容:</label>
                <BraftEditor
                    value={this.state.editorState}
                    onChange={(editorState)=> this.setState({editorState: editorState})}
                    style={{borderWidth: 1, borderStyle: "solid", borderColor: "#d9d9d9"}}
                    excludeControls={excludeControls}
                    extendControls={extendControls}
                    placeholder="请输入例子内容"
                />
                <Form.Item>
                    <Button type="primary" htmlType="submit" style={{marginTop: 20}} loading={this.props.loading}>
                        {this.props.defaultFormValue ? '更新例子' : '增加例子'}
                    </Button>
                </Form.Item>
            </Form>
        );
    }
}
